module.exports = __webpack_public_path__ + "img/组 127(1).dcf60cb3.png";